import { useEffect } from 'react'

export const useBfCacheCheck = () => {
  useEffect(() => {
    const cb = (event: PageTransitionEvent) => {
      if (event.persisted) {
        // Reload page
        location.reload()
      }
    }
    window.addEventListener('pageshow', cb)
    return () => {
      window.removeEventListener('pageshow', cb)
    }
  }, [])
}
